/** @format */

import {Box} from '@mui/material';
import {styled} from '@mui/material/styles';

const Root = styled(Box)(({theme}) => ({
  display: 'flex',
  gap: theme.spacing(2),
  flexWrap: 'wrap',
}));

export {Root as WidgetsListRoot};
